// PenWidthSlider — 旧版 `PaintToolCanvas.java:498-509` (paint) + `:792-816`
// (mouseDragged) の太さ調整バー TS port.
//
// 2026-05-09 (consult): 内部実装を `LegacyGaugeSlider` に委譲する thin wrapper に
// 縮小した. core ロジック (Pointer Capture / outsetFrame / 黒塗りゲージ / R10/R11
// 修正パターン) は共通 component に集約済 — 筆圧設定 UI でも同じスタイルを使う
// ためで, ここから漏れる旧版踏襲の「ノスタルジー要件」は無い.
//
// 既存呼び出し側 (`ToolPanel.tsx`) は props (`value`, `onChange`) を変えずに
// そのまま渡せる. 既存 `penWidthSlider.test.ts` は `xToPenWidth` / `penWidthToX`
// の pure helper を直接テストしており, この wrapper には影響しない.

import { LegacyGaugeSlider } from './LegacyGaugeSlider.js';
import { MAX_PEN_WIDTH } from './penWidthSlider.js';

export interface PenWidthSliderProps {
  /** 現在の幅 (= 選択中 cell の値). 0..MAX_PEN_WIDTH. */
  readonly value: number;
  /** ドラッグ中に発火. 値は内部で 0..MAX_PEN_WIDTH に clamp 済. */
  readonly onChange: (next: number) => void;
}

export const PenWidthSlider = ({ value, onChange }: PenWidthSliderProps): React.ReactNode => (
  <LegacyGaugeSlider
    value={value}
    valueMin={0}
    valueMax={MAX_PEN_WIDTH}
    step={1}
    onChange={onChange}
    ariaLabel="ペン太さ調整"
    ariaValueText={(v) => `現在の太さ ${v}px`}
    manualId="draw.size"
  />
);
